import React, { createContext, useContext, useState, ReactNode } from 'react';
import { scroller } from 'react-scroll';

interface ContactContextType {
  prefillMessage: string;
  requestContact: (message?: string) => void;
  consumePrefill: () => void;
}

const ContactContext = createContext<ContactContextType | undefined>(undefined);

export const ContactProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [prefillMessage, setPrefillMessage] = useState('');

  const requestContact = (message?: string) => {
    setPrefillMessage(message ?? '');
    scroller.scrollTo('contact-section', { smooth: true, duration: 500, offset: -80 });
  };

  const consumePrefill = () => setPrefillMessage('');

  return (
    <ContactContext.Provider value={{ prefillMessage, requestContact, consumePrefill }}>
      {children}
    </ContactContext.Provider>
  );
};

export const useContact = () => {
  const ctx = useContext(ContactContext);
  if (!ctx) throw new Error('useContact must be used within ContactProvider');
  return ctx;
};
